import React from "react";
import { CheckOutlined } from "@ant-design/icons";

interface SuccessNotificationProps {
  message: string;
}

const SuccessNotification: React.FC<SuccessNotificationProps> = ({
  message,
}) => {
  return (
    <div 
      className="px-6 py-4 rounded-3xl outline outline-1 outline-offset-[-1px] inline-flex justify-start items-center gap-3"
      style={{
        backgroundColor: '#F0FDF4', // Background-Semantic-Success-Subtle (light green)
        outlineColor: '#22C55E', // Border-Semantic-Success-Primary (green)
      }}
    >
      <div
        data-property-1="Default"
        className="w-6 h-6 rounded-full flex justify-center items-center"
        style={{
          backgroundColor: '#22C55E', // Background-Semantic-Success-Bold (green)
          padding: '10px',
        }}
      >
        <CheckOutlined style={{ fontSize: '16px', color: '#fff' }} />
      </div>
      <div className="justify-start text-base font-normal font-['Inter'] leading-8" style={{ color: 'rgba(10, 10, 10, 0.9)' }}>
        {message}
      </div>
    </div>
  );
};

export default SuccessNotification;

